module.exports = "/static/fonts/OpenSans-BoldItalic.eot";